import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findEducations = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/education${query}`, {
        headers,
    });
};

export const findEducationById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/education/${id}`, {
        headers,
    });
};
